import { DEFAULT_LANG } from './config';

/**
 * 多言語オブジェクト（{ ja, en, 'zh-CN', 'zh-TW' }）から現在言語の値を取り出す。
 * 訳が無い・空の言語は日本語にフォールバックし、画面が空になるのを防ぐ。
 */
export function pick(field, lang) {
  if (!field) return '';
  if (typeof field === 'string') return field;
  return field[lang] || field[DEFAULT_LANG] || '';
}

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * ニュースのISO日付（2026-07-16）を言語別の表記に整形する。
 * ja: 2026.07.16 / en: July 16, 2026 / zh: 2026年7月16日
 */
export function formatNewsDate(isoDate, lang) {
  const matched = ISO_DATE.exec(isoDate ?? '');
  if (!matched) return isoDate ?? '';

  const [, year, month, day] = matched;
  if (lang === 'ja') return `${year}.${month}.${day}`;

  // UTCで組み立ててUTCで整形する。ローカルタイムゾーンで解釈すると
  // 年末年始などの境界で1日ずれる。
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  return new Intl.DateTimeFormat(lang, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}
